/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointonebold2Inputs */

const ja_home_agency_pointonebold2 = /** @type {(inputs: Home_Agency_Pointonebold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インターネットユーザーの82％  <abbr title='3.2 Billion'>（32億人）</abbr> がゲームをプレイしています。`)
};

const en_home_agency_pointonebold2 = /** @type {(inputs: Home_Agency_Pointonebold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82% of internet users <abbr title='3.2 Billion'>(3.2B)</abbr> people play video games.`)
};

/**
* | output |
* | --- |
* | "82% of internet users <abbr title='3.2 Billion'>(3.2B)</abbr> people play video games." |
*
* @param {Home_Agency_Pointonebold2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointonebold2 = /** @type {((inputs?: Home_Agency_Pointonebold2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointonebold2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointonebold2(inputs)
	return en_home_agency_pointonebold2(inputs)
});
export { home_agency_pointonebold2 as "home_agency_pointOneBold" }